import { CustomRouteConfig } from "@/models/plugins/CustomRouterTypes";
import PERMISSIONS from "@/static/permissions";

const DocumentsRoutes: Array<CustomRouteConfig> = [
  {
    name: "Documents",
    path: "documents",
    component: () => import(/* webpackChunkName: "documents" */ "@/views/documents/DocumentsView.vue"),
    meta: { hasOneOfPermissions: [PERMISSIONS.DocumentsRead] },
  },

  {
    name: "Edit document",
    path: "documents/edit/:documentId/:orderId",
    component: () => import(/* webpackChunkName: "orders" */ "@/views/documents/DocumentEditView.vue"),
    meta: { hasOneOfPermissions: [PERMISSIONS.DocumentsUpdate] },
  },

  {
    name: "VAT Margin Settlements",
    path: "vat-margin-settlements",
    component: () =>
      import(/* webpackChunkName: "vat-margin-settlements" */ "@/views/documents/VATMarginSettlementsView.vue"),
  },
];

export { DocumentsRoutes };
export default DocumentsRoutes;
